import {Component, Host, h, Prop, Event, EventEmitter, Watch} from '@stencil/core';
import {Logger} from "../../utils/logger";
import {IRequestField} from "../../interfaces/configuration";

@Component({
  tag: 'securecall-request-select',
  styleUrl: 'securecall-request-select.css',
  shadow: true,
})
export class SecurecallRequestSelect {
  @Prop() fieldName: string;
  @Prop({ mutable: true }) config: IRequestField;

  @Event() isValidEvent: EventEmitter<{ field: string; valid: boolean, value: string }>;

  private readonly log = new Logger('SecurecallRequestSelect')
  private selectElement: HTMLSelectElement;

  @Event() changed: EventEmitter<string>

  public get value(): string {
    return this.config.value;
  }
  public set value(value: string) {
    if (this.config.value !== value) {
      this.config.value = value;
      this.validateChange();
    }
  }

  @Watch('config')
  handleConfigChange(newConfig: any, oldConfig: any) {
    this.log.debug(this.fieldName + ": handleConfigChange: config", newConfig, oldConfig);
    if(oldConfig.value !== newConfig.value) {
      this.value = newConfig.value;
      this.validateChange();
      if(this.selectElement) this.selectElement.value = this.value;
    } else if(oldConfig.valid !== newConfig.valid) {
      this.validateChange();
    }
  }

  componentWillLoad() {
    this.log.debug(this.fieldName + ": componentWillLoad: config", this.config);
    if(this.config.value === undefined)
      this.value = Object.entries(this.config.possibleValues)[0][0] || '';
    this.validateChange();
  }

  handleChange(ev) {
    this.log.debug(this.fieldName + ": handleChange: select change:", ev.target.value);
    this.value = ev.target.value;
  }

  validateChange() {
    const input = this.value;
    let isValid = false;
    if (input && input.length > 0) {
      isValid = true;
    }
    this.isValidEvent.emit({ field: this.fieldName, valid: isValid, value: input });
  }

  render() {
    return (
      <Host>
        <div class="field-container">
          <label class="custom-label">
            {this.config["label"]}:
          </label>
          <select
            class="custom-select"
            id={this.fieldName}
            disabled={this.config.readOnly}
            onChange={(ev) => this.handleChange(ev)}
            ref={(el) => this.selectElement = el}
          >
            {typeof this.config.possibleValues === 'object' && this.config.possibleValues !== null ? (
              Object.entries(this.config.possibleValues).map(([key, val]) => (
                <option value={key} selected={key === this.value}>
                  {val}
                </option>
              ))
            ) : null}
          </select>
          <div class="validity none"></div>
        </div>
      </Host>
    );
  }
}
